__turbopack_context__.v({
  "Tag": "TPtOba_Tag",
  "Tag--Black": "TPtOba_Tag--Black",
  "Tag--Green": "TPtOba_Tag--Green",
  "Tag--Red": "TPtOba_Tag--Red",
});
